import { FC } from 'react';
import { PromotedServiceAssignment } from '@mews-commander/data-access';
import { lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Spinner, Stack, Typography } from '@optimus-web/core';
import {
    DescriptionField,
    RateSelectionField,
    SpaceCategoryField,
    OptionsField,
    PromotionLimitField,
    IntervalLimitField,
    OrderingField,
    CreatedAndUpdatedFields,
} from './fields';
import { useRequiredFieldsData } from './hooks/useRequiredFieldsData';

interface ServicePromotionSettingsProps {
    serviceId: string;
    enterpriseId: string;
    promotedServiceId: string;
    isEditMode: boolean;
    promotedService?: PromotedServiceAssignment;
}

export const ServicePromotionSettings: FC<ServicePromotionSettingsProps> = ({
    promotedServiceId,
    enterpriseId,
    serviceId,
    isEditMode,
    promotedService,
}) => {
    const { rateData, spaceCategoryData, selectedService, isLoading } = useRequiredFieldsData({
        promotedServiceId,
        enterpriseId,
        serviceId,
    });

    if (isLoading) {
        return (
            <Stack fill distribution="space-around" alignment="center" itemAlignment="center">
                <Spinner />
            </Stack>
        );
    }

    if (!selectedService) return null;

    return (
        <Stack vertical distribution="space-between" spacing="300">
            <SpaceCategoryField data={spaceCategoryData} isEditMode={isEditMode} />
            <RateSelectionField data={rateData} isEditMode={isEditMode} />
            <DescriptionField data={spaceCategoryData} />
            <Typography textStyle="titleMediumStrong" as="div">
                {lt(TextKey.PromotedServiceAssignmentDialogSettings)}
            </Typography>
            <OptionsField />
            <PromotionLimitField />
            <IntervalLimitField selectedService={selectedService} />
            <OrderingField />
            {promotedService && <CreatedAndUpdatedFields promotedService={promotedService} />}
        </Stack>
    );
};
